import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onActionClick }) => {
  const quickActions = [
    {
      id: 'set-goal',
      title: 'Set New Goal',
      description: 'Define your wellness objectives',
      icon: 'Target',
      color: 'bg-primary',
      route: '/progress-tracking?action=new-goal'
    },
    {
      id: 'join-workshop',
      title: 'Join Workshop',
      description: 'Book expert-led sessions',
      icon: 'Calendar',
      color: 'bg-accent',
      route: '/events-and-workshops'
    },
    {
      id: 'community-post',
      title: 'Share Experience',
      description: 'Connect with community',
      icon: 'MessageSquare',
      color: 'bg-secondary',
      route: '/community-forums?action=new-post'
    },
    {
      id: 'marketplace',
      title: 'Explore Marketplace',
      description: 'Discover wellness products',
      icon: 'ShoppingBag',
      color: 'bg-success',
      route: '/wellness-marketplace'
    }
  ];

  const handleActionClick = (action) => {
    onActionClick?.(action);
    window.location.href = action?.route;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-wellness">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-heading font-semibold text-foreground">Quick Actions</h2>
        <Icon name="Zap" size={20} className="text-accent" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => handleActionClick(action)}
            className="flex items-center space-x-4 p-4 rounded-lg border border-border hover:border-primary/20 hover:bg-primary/5 transition-wellness text-left group"
          >
            <div className={`w-12 h-12 ${action?.color} rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-transform`}>
              <Icon name={action?.icon} size={20} color="white" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground group-hover:text-primary transition-wellness">
                {action?.title}
              </h3>
              <p className="text-xs text-muted-foreground mt-1">{action?.description}</p>
            </div>
            <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-primary transition-wellness" />
          </button>
        ))}
      </div>
      {/* LIGHT System Guidance */}
      <div className="mt-6 p-4 rounded-lg bg-accent/5 border border-accent/10">
        <div className="flex items-center space-x-3 mb-3">
          <div className="w-8 h-8 bg-accent rounded-full flex items-center justify-center">
            <Icon name="Lightbulb" size={16} color="white" />
          </div>
          <h3 className="text-sm font-medium text-foreground">LIGHT System Guidance</h3>
        </div>
        <p className="text-xs text-muted-foreground mb-3">
          Personalized recommendations based on your wellness journey and preferences.
        </p>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => window.location.href = '/progress-tracking?section=guidance'}
          className="w-full"
        >
          View Recommendations
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;